import { FC } from 'react'
import { ComponentProps } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { ProductColorGroupWithUnavailable } from '../../../../../../types/figs'

import { Container, StyledColorAttribute } from './styles'

export interface ColorGroupsSectionProps {
  colorGroups: ProductColorGroupWithUnavailable[]
  hasSelectedSize: boolean
  isCurrentColorCompletelySoldOut: boolean
  isProductWaitlistable: boolean
  onColorSelect: ComponentProps<typeof StyledColorAttribute>['onSelect']
  selectedColorKey: string | undefined
  /* Whether the original color group label should be used. The component will use our singular "color" label if there is only a single color group by default. */
  retainColorGroupLabel?: boolean
}

export const ColorGroupsSection: FC<ColorGroupsSectionProps> = ({
  colorGroups,
  hasSelectedSize,
  isCurrentColorCompletelySoldOut,
  isProductWaitlistable,
  onColorSelect,
  selectedColorKey,
  retainColorGroupLabel = false,
}) => {
  const {
    detailsSection: { colorTitle },
  } = useTranslation()

  return (
    <Container data-testid='color-picker'>
      {colorGroups.map(
        cg =>
          cg.colors.length > 0 && (
            <StyledColorAttribute
              key={cg.label}
              title={colorGroups.length === 1 && !retainColorGroupLabel ? colorTitle : cg.label}
              selected={cg.colors.find(({ rawName }) => rawName === selectedColorKey)}
              label={cg.label}
              onSelect={onColorSelect}
              colors={cg.colors}
              withTooltip={retainColorGroupLabel || colorGroups.length > 1}
              soldOut={
                isCurrentColorCompletelySoldOut && !hasSelectedSize && !isProductWaitlistable
              }
            />
          )
      )}
    </Container>
  )
}
